import script from "./SlotModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlotModal.vue?vue&type=script&lang=ts&setup=true"

import "./SlotModal.vue?vue&type=style&index=0&id=24df84a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24df84a0"]])

export default __exports__